import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const permissionApi = {
  getPermissions: async () => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.PERMISSIONS}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching permissions:', error);
      throw error;
    }
  },
};

export default permissionApi;